module.exports = __webpack_public_path__ + "img/yesOrNoEle.a1082d20.svg";